<template>
   <v-container class="login-container bg-dot-img">
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
        <LoginImageComponent />
      </v-col>
      <v-col
          cols="12"
          md="6"
        >
        <RegisterComponentForm />
      </v-col>
    </v-row>
  </v-container>
 </template>
 <script>
  import LoginImageComponent from './common/LoginImageComponent.vue';
  import RegisterComponentForm from './Register/RegisterComponentForm.vue';
   export default {
  components: {
       LoginImageComponent,
       RegisterComponentForm,
      },
  data: () => ({
    //
  }),
  methods: {
  }
};
 </script>